import Image from 'next/image'

import RoyaleRibbon from '@/assets/images/storefronts/clashroyale/value-ribbon.png'

import styles from './royaleValueIndicator.module.scss'

//TODO: Intl for "value"

export const RoyaleValueIndicator = ({ value }: { value: number }) => {
  return (
    <div className={styles.valueIndicator}>
      <div className={styles.icons}>
        <Image src={RoyaleRibbon} alt="royale ribbon" width={46} />
      </div>
      <div className={styles.textWrapper}>
        <div className={styles.valueNumber}>
          {value}
          <span>x</span>
        </div>
        <div className={styles.valueText}>value</div>
      </div>
    </div>
  )
}
